import React from 'react'
import injectStyles from 'react-jss'

import { PageNav, PageNavItem } from '../../../../Components/PageNav'
import { NAV } from '../../../../Config/Routing/nav'
import { PATHS } from 'Config/Routing/paths'
import { authorization } from 'Module/Auth/Auth'

const styles = {
  wrapper: {
    marginLeft: '40px',
  },
}
export const CampaignHeaderNav = injectStyles(styles)(
  ({ history, match, showBonusTab, classes, campaignId }) => {
    const BASE_URL =
      PATHS.main.dashboard + PATHS.dashboard.campaigns + '/' + campaignId + '/'

    return (
      <PageNav history={history}>
        <PageNavItem href={BASE_URL + NAV.CAMPAIGN_HEADER_NAV.DASHBOARD}>
          Dashboard
        </PageNavItem>
        {(authorization.isCityManager() || authorization.isClient()) &&
        !authorization.isSpy() ? (
          <PageNavItem href={BASE_URL + NAV.CAMPAIGN_HEADER_NAV.LIVE_MAP}>
            Live Map
          </PageNavItem>
        ) : null}
        <PageNavItem href={BASE_URL + NAV.CAMPAIGN_HEADER_NAV.CITY_PLANS}>
          City Plans
        </PageNavItem>
        <PageNavItem href={BASE_URL + NAV.CAMPAIGN_HEADER_NAV.MASTER_SCHEDULE}>
          Master Schedule
        </PageNavItem>
        {!authorization.isClient() && (
          <PageNavItem
            href={BASE_URL + NAV.CAMPAIGN_HEADER_NAV.MANAGE_PAID_AMOUNTS}
          >
            Client Permit Costs
          </PageNavItem>
        )}
        {showBonusTab && (
          <PageNavItem href={BASE_URL + NAV.CAMPAIGN_HEADER_NAV.BONUS_RESULTS}>
            Bonus Results
          </PageNavItem>
        )}
        <PageNavItem href={BASE_URL + NAV.CAMPAIGN_HEADER_NAV.CLIENT_QUESTIONS}>
          Client Questions
        </PageNavItem>
      </PageNav>
    )
  },
)
export default CampaignHeaderNav



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/Page/HeaderNav/index.js